import { createAction } from '@reduxjs/toolkit';

export const ADD_USER_BY_PHONE = 'products/getEmptyProducts';

export const addEmptyArray = createAction(
    ADD_USER_BY_PHONE,
    () => ({ payload: { userByPhone: [] } }),
);
